// Chat placeholders and their persisted notification share a message URL.
// Other events can share a destination while representing separate updates.
export function notificationIdentity(notification) {
    if (notification?.route?.includes("/chat/chat-group/")) {
        return notification.route;
    }
    return notification?._id ?? notification?.ID ?? notification?.route;
}

export function sameNotification(left, right) {
    const leftKey = notificationIdentity(left);
    return leftKey != null && leftKey === notificationIdentity(right);
}
